import { useCallback } from 'react';
import { useAtlasClient } from '@sekoia/shared/hooks/common/useAtlasClient';
import CacheKeys from '@sekoia/shared/constants/CacheKeys';
import { useQueryWithRetry } from '@sekoia/shared/hooks/helpers/useQueryWithRetry';
import { UseQueryResult } from '@tanstack/react-query';
import { AffiliationResponse } from '@sekoia/shared/requests/nswagClients/AtlasClient';

export const useFetchAffiliations = (): UseQueryResult<AffiliationResponse[], Error> => {
  const { userClient } = useAtlasClient();

  const getAffiliations = useCallback(async () => {
    return await userClient.getAffiliations();
  }, [userClient]);

  return useQueryWithRetry({
    queryKey: [CacheKeys.AFFILIATIONS],
    queryFn: () => getAffiliations(),
  });
};
